const OrderTypes = Object.freeze({
    0: "LUMBER",
    1: "TRUSS",
    2: "HARDWARE",
  });
  
  export default OrderTypes;